export default "__VITE_ASSET__29e83877__"